import { render, staticRenderFns } from "./AcquisitionFlowNavbar.vue?vue&type=template&id=90e51992&scoped=true&"
import script from "./AcquisitionFlowNavbar.vue?vue&type=script&lang=js&"
export * from "./AcquisitionFlowNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AcquisitionFlowNavbar.vue?vue&type=style&index=0&id=90e51992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e51992",
  null
  
)

export default component.exports